import { render, staticRenderFns } from "./HikPantalla.vue?vue&type=template&id=7db57263&scoped=true&"
import script from "./HikPantalla.vue?vue&type=script&lang=ts&"
export * from "./HikPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./HikPantalla.vue?vue&type=style&index=0&id=7db57263&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db57263",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7db57263', component.options)
    } else {
      api.reload('7db57263', component.options)
    }
    module.hot.accept("./HikPantalla.vue?vue&type=template&id=7db57263&scoped=true&", function () {
      api.rerender('7db57263', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/Hik/HikPantalla.vue"
export default component.exports